import { Component } from '@angular/core';
import { OpenIdService } from '@quickweb/authenticator-angular';
@Component({
  selector: 'app-idp-callback',
  standalone: true,
  imports: [],
  templateUrl: './idp-callback.component.html',
})
export class IdpCallBackComponent {
  constructor(private openId: OpenIdService) {}

  async ngOnInit() {
    this.openId.checkAuth().subscribe((e) => {
      if (e.isAuthenticated) {
        console.log('usuario logados');
        const centralId = localStorage.getItem('centralId');
        const redirectUri = `${window.location.protocol}//${window.location.host}/centrais/${centralId}`;
        window.location.href = redirectUri;
      }
    });
  }
}
